import { ApiPermissions, DropListWithIconItem } from "@cede/types";
import { useArrayListener } from "@/hooks/core/useArrayListener";
import { useHubUser } from "@/hooks/user/useHubUser";

/**
 * Detect when a new account is added and select it
 */
export const useNewAccountAdded = (
  availableForTradeAccounts: DropListWithIconItem<{
    permissions: ApiPermissions[];
    cexValue: string;
  }>[],
  onNewAccountAdded?: (
    account: DropListWithIconItem<{
      permissions: ApiPermissions[];
      cexValue: string;
    }>,
  ) => void,
  availableForTradeAccountsAreLoading?: boolean,
) => {
  const { isLoadingHubUser } = useHubUser();

  /**
   * @remarks
   * If a new account is added, we want to select it automatically
   */
  useArrayListener({
    array: availableForTradeAccounts,
    identifierKey: "value",
    onNewItem: (account) => {
      if (onNewAccountAdded) {
        onNewAccountAdded(account);
      }
    },
    /**
     * @remarks
     * We enable the detection only after:
     * 1. Hub user data has finished loading for the first time
     * 2. Available accounts are not currently loading (initial load is complete)
     * This ensures we don't trigger during initial account population, but do trigger when users actually connect new accounts
     */
    enabled: !isLoadingHubUser && !availableForTradeAccountsAreLoading,
  });
};
